import { useState } from 'preact/hooks'
import { ChevronLeft, ChevronRight } from 'lucide-preact'
import { format } from 'date-fns'
import { fr } from 'date-fns/locale'
import { dateKey, monthDays } from '../lib/cycle'
import { dayProgress, tasksForDate, tasksForMember } from '../lib/plan'
import type { Plan } from '../types'

export function Month({
  anchor,
  plan,
  done,
  memberId,
  onSelectDate,
}: {
  anchor: Date
  plan: Plan
  done: ReadonlySet<string>
  memberId: string
  onSelectDate: (date: Date) => void
}) {
  const [monthOffset, setMonthOffset] = useState(0)
  const month = new Date(anchor.getFullYear(), anchor.getMonth() + monthOffset, 1, 12)
  const days = monthDays(month.getFullYear(), month.getMonth())
  const today = dateKey(new Date())

  return (
    <section class="card">
      <div class="month-header">
        <button class="icon-button" onClick={() => setMonthOffset((v) => v - 1)} aria-label="Mois précédent">
          <ChevronLeft size={22} />
        </button>
        <h2>{format(month, 'MMMM yyyy', { locale: fr })}</h2>
        <button class="icon-button" onClick={() => setMonthOffset((v) => v + 1)} aria-label="Mois suivant">
          <ChevronRight size={22} />
        </button>
      </div>

      <div class="week-labels">
        {['L', 'M', 'M', 'J', 'V', 'S', 'D'].map((d) => <span>{d}</span>)}
      </div>

      <div class="month-grid">
        {/* The grid starts on Monday; getDay() starts on Sunday. */}
        {Array.from({ length: (days[0].getDay() + 6) % 7 }).map(() => <span class="empty-day" />)}

        {days.map((day) => {
          const taskDate = dateKey(day)
          // Filtered by member for the same reason the day list is, and with
          // the same call: a cell that counted the whole household's chores
          // against one person's ticks would read 3/9 for a day they finished.
          const tasks = tasksForMember(tasksForDate(day, plan), memberId)
          const progress = dayProgress(tasks, taskDate, memberId, done)

          return (
            <button
              class={`day-cell ${taskDate === today ? 'today-cell' : ''}`}
              onClick={() => onSelectDate(day)}
            >
              <strong>{day.getDate()}</strong>
              <span>{progress.done}/{progress.total}</span>
              <i style={{ width: `${progress.percent}%` }} />
            </button>
          )
        })}
      </div>
    </section>
  )
}
